import { QUERY_KEYS } from "constants/query-keys";
import { useQuery } from "@tanstack/react-query";
import apiClient from "api/api-client";
import { StaticContent, StaticContentPageEnum } from "types/static-content";
import { isSuccessStatus } from "utils/is-success-status";

export const useGetInformationalContentPage = (page: StaticContentPageEnum) => {
  return useQuery({
    queryKey: [QUERY_KEYS.informationalContentPageGet, page],
    queryFn: async () => {
      const response = await apiClient.get<StaticContent>(`/public/informational-content/pages/${page}`);
      if (!isSuccessStatus(response.status)) {
        throw new Error("Failed to load informational content page");
      }

      return response.data;
    },
  });
};
